import {ProjectSystemType} from "../../../../../../../../core/model2/project/types"
import {ViewType} from "../../../../../../../../core/gd/const/views/view-type"

// used also when create new folder/tag
export default function project_getDefaultViewTypes(systemType: ProjectSystemType) {
    if (systemType === ProjectSystemType.TAG) {
        return [
            ViewType.PROJECT_LIST,
            ViewType.PROJECT_TABLE,
            ViewType.PROJECT_BOARD,
        ];
    } else {
        return [
            ViewType.PROJECT_DISCUSSION,
            ViewType.PROJECT_TABLE,
            ViewType.PROJECT_BOARD,
            ViewType.PROJECT_GANTT,
            ViewType.PROJECT_WORKLOAD,
            ViewType.PROJECT_CALENDAR,
            ViewType.PROJECT_FILES,
            ViewType.PROJECT_DOCS,
            ViewType.PROJECT_ACTIVITY,
            ViewType.PROJECT_MEETINGS,
            ViewType.PROJECT_REQUEST_FORMS,
        ]
    }
}